import { dateTimeToView } from "helpers/date";
import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

export default function DriverShiftPoint({ driverShift }) {
    if (!driverShift?.point) {
        return null;
    }

    const options = {
        position: [driverShift.point.location[1], driverShift.point.location[0]],
        icon: divIcon({ className: "map-icon--item-changes", iconSize: [22, 22] }),
        zIndexOffset: 1000,
    };
    return (
        <Marker {...options}>
            <Tooltip
                className="map__tooltip-route-marker map__tooltip-route-marker--dark leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div>
                    <b>Пересменка</b>
                    <div>
                        Адрес: <b>{driverShift.address}</b>
                    </div>
                    <div>
                        Плановая дата: <b>{dateTimeToView(driverShift.startDate)}</b>
                    </div>
                    <div>
                        ФИО водителя (сменяемого): <b>{driverShift.driverName}</b>
                    </div>
                    {driverShift.comment && (
                        <div>
                            Комментарий: <b>{driverShift.comment}</b>
                        </div>
                    )}
                </div>
            </Tooltip>
        </Marker>
    );
}
